import * as React from 'react';

import { SalesOrderGenericDialog } from './SalesOrderGenericDialog';

import { useTranslations } from '~/modules/trade/i18n/useTranslations';

interface SalesOrderMarkAsClosedDialogProps {
  onConfirm: () => Promise<void>;
  onCancel: () => void;
}

export const SalesOrderMarkAsClosedDialog: React.FC<
  SalesOrderMarkAsClosedDialogProps
> = ({ onConfirm, onCancel }) => {
  const t = useTranslations();

  return (
    <SalesOrderGenericDialog
      onConfirm={onConfirm}
      onCancel={onCancel}
      message={t.closeSalesOrderDialog.message}
      title={t.closeSalesOrderDialog.title}
      confirmLabel={t.closeSalesOrderDialog.confirm}
      cancelLabel={t.closeSalesOrderDialog.cancel}
      className="@SalesOrderMarkAsClosedDialog"
    />
  );
};
